import _sortBy from 'lodash.sortby';
import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import { redirectToSettingsIfNoPermission } from 'cio/utils/route-access';

export default class BillingHistoryRoute extends Route {
  @service store!: DS.Store;

  crumb() {
    return {
      name: 'Billing History',
      path: this.routeName,
      helpQuery: 'bill invoices',
    };
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    return redirectToSettingsIfNoPermission(this, 'account/billing/view', transition);
  }

  model() {
    return this.store.findAll('receipt').then((receipts) => _sortBy(receipts, ['invoicedAt']).reverse());
  }
}
